/* CheekyGlo skin quiz. Markup and product data: sections/cg-skin-quiz.liquid */
(function () {
  'use strict';

  var root = document.querySelector('[data-cgq]');
  if (!root || root.__cgq) return;
  root.__cgq = true;

  var cfg = JSON.parse(root.querySelector('[data-cgq-config]').textContent);
  var P = JSON.parse(root.querySelector('[data-cgq-products]').textContent);
  var STORE = 'cgq-v1';

  function $(s, el) { return (el || root).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  function has(list, v) { return Array.isArray(list) && list.indexOf(v) !== -1; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data || {})); } catch (e) {}
  }

  var fmt;
  try { fmt = new Intl.NumberFormat('en-AU', { style: 'currency', currency: cfg.currency || 'AUD' }); } catch (e) { fmt = null; }
  function money(cents) {
    var n = Math.round(cents) / 100;
    var s = fmt ? fmt.format(n) : '$' + n.toFixed(2);
    return s.replace(/\.00$/, '').replace(/^A\$/, '$');
  }

  $$('[data-cgq-num]').forEach(function (el) { el.textContent = Number(el.textContent).toLocaleString('en-AU'); });

  /* ------------------------------------------------------------------
     QUESTIONS
     ------------------------------------------------------------------ */
  var CONCERNS = {
    rough:    { label: 'Rough, dry or dull skin', desc: 'Flaky patches, rough texture or no glow', tag: 'Rough skin', phrase: 'rough, dry skin' },
    kp:       { label: 'Bumps, KP or strawberry legs', desc: 'Little bumps on arms, thighs or bum', tag: 'KP and bumps', phrase: 'KP bumps' },
    bodyacne: { label: 'Body breakouts', desc: 'Spots on your back, chest or shoulders', tag: 'Body breakouts', phrase: 'body breakouts' },
    ingrown:  { label: 'Ingrown hairs and razor bumps', desc: 'After shaving or waxing', tag: 'Ingrown hairs', phrase: 'ingrown hairs' },
    tan:      { label: 'Patchy fake tan', desc: 'Streaks, dark knees, old tan that won\'t budge', tag: 'Fake tan', phrase: 'patchy tan' },
    feet:     { label: 'Cracked heels and rough feet', desc: 'Hard skin, calluses, sandal panic', tag: 'Your feet', phrase: 'rough feet' },
    face:     { label: 'Dull or congested face', desc: 'Texture, clogged pores, makeup sitting weird', tag: 'Your face', phrase: 'your face' },
    hair:     { label: 'Dry hair or itchy scalp', desc: 'Frizz, straw ends, flakes or build-up', tag: 'Hair and scalp', phrase: 'your hair and scalp' },
    lips:     { label: 'Dry or flat lips', desc: 'Chapped, peeling, or you want more pout', tag: 'Your lips', phrase: 'your lips' }
  };

  var INSIGHTS = {
    rough: ['Rough skin is mostly build-up', 'Your skin sheds dead cells every day and plenty of them just sit there. Buffing them off twice a week, then locking moisture in, is usually all it takes to get the soft back.'],
    kp: ['KP is really common, and it\'s manageable', 'Those bumps are keratin plugging your hair follicles. Nothing cures KP, but gentle exfoliation plus moisture, done consistently, makes it feel way smoother. Think weeks, not overnight.'],
    bodyacne: ['Body breakouts love sweat and build-up', 'Back and chest spots are often dead skin, sweat and product trapping oil in your pores. Keeping those spots properly cleaned and exfoliated makes a real difference. Just never scrub anything angry or open.'],
    ingrown: ['Most ingrowns are hairs stuck under dead skin', 'When dead skin sits over a follicle, the hair curls back instead of breaking through. Exfoliating a day or two before you shave keeps the path clear.'],
    tan: ['Patchy tan starts before you tan', 'Tan grabs onto dry, flaky spots. That\'s why knees and ankles go dark and the rest fades unevenly. Smooth skin before, hydrated skin after.'],
    feet: ['Your heels are working hard', 'Hard skin builds up as protection, then cracks when it dries out. The fix is taking the build-up off slowly and keeping it moisturised, not hacking at it.'],
    face: ['Face skin needs a softer touch', 'The skin on your face is thinner than your body, so gentle and regular beats harsh and occasional. Two or three times a week is plenty.'],
    hair: ['Your shower water could be part of it', 'Chlorine and minerals in tap water can leave hair dry and your scalp itchy, however good your shampoo is. That\'s why we\'ll ask about your shower in a sec.'],
    lips: ['Lips have no oil glands', 'That\'s why they dry out faster than the rest of your face. They need something that seals moisture in, not just a quick gloss.']
  };

  var STEPS = [
    { id: 'who', eyebrow: 'About you', title: 'Who\'s getting the glow-up?', sub: 'Shopping for someone? Answer for them and we\'ll match it to their skin.', type: 'single',
      options: [
        { v: 'me', label: 'Me', desc: 'Treat yourself' },
        { v: 'him', label: 'Him', desc: 'Boyfriend, husband, brother, dad' },
        { v: 'gift', label: 'It\'s a gift', desc: 'For someone who deserves a glow' }
      ] },
    { id: 'concerns', eyebrow: 'Your skin', title: 'What do you want to fix first?', sub: 'Pick up to 3, biggest one first. We\'ll build your routine around it.', type: 'multi', max: 3, cols: 'wide',
      options: Object.keys(CONCERNS).map(function (k) { return { v: k, label: CONCERNS[k].label, desc: CONCERNS[k].desc }; }),
      why: 'Your first pick becomes the hero of your routine.' },
    { id: 'insight', type: 'insight' },
    { id: 'kpAreas', eyebrow: 'KP and bumps', title: 'Where do you want smooth skin?', sub: 'Pick every spot you want smoothed out.', type: 'multi', max: 4,
      when: function (a) { return has(a.concerns, 'kp'); },
      options: [
        { v: 'arms', label: 'Upper arms' }, { v: 'legs', label: 'Thighs and legs' },
        { v: 'bum', label: 'Bum' }, { v: 'back', label: 'Back' }
      ] },
    { id: 'acneAreas', eyebrow: 'Body breakouts', title: 'Where do you want clearer skin?', sub: 'Pick every spot that breaks out.', type: 'multi', max: 3,
      when: function (a) { return has(a.concerns, 'bodyacne'); },
      options: [
        { v: 'back', label: 'Back' }, { v: 'shoulders', label: 'Shoulders' }, { v: 'chest', label: 'Chest' }
      ] },
    { id: 'feet', eyebrow: 'Your feet', title: 'How are your heels right now?', type: 'single',
      when: function (a) { return has(a.concerns, 'feet'); },
      options: [
        { v: 'rough', label: 'A bit rough', desc: 'Dry, but nothing dramatic' },
        { v: 'hard', label: 'Hard skin and calluses', desc: 'Thick, yellowy, catches on socks' },
        { v: 'cracked', label: 'Cracked and sore', desc: 'Splits that hurt or bleed' }
      ] },
    { id: 'face', eyebrow: 'Your face', title: 'What do you want to change about your face?', sub: 'Pick up to 2.', type: 'multi', max: 2,
      when: function (a) { return has(a.concerns, 'face'); },
      options: [
        { v: 'dull', label: 'Dull and rough', desc: 'No glow, uneven texture' },
        { v: 'pores', label: 'Clogged pores', desc: 'Blackheads, little breakouts' },
        { v: 'red', label: 'Red and reactive', desc: 'Flushes, stings, gets angry easily' },
        { v: 'fuzz', label: 'Peach fuzz', desc: 'Makeup won\'t sit smooth' },
        { v: 'makeup', label: 'Makeup takes ages to remove', desc: 'Wipes, scrubbing, still panda eyes' }
      ] },
    { id: 'hair', eyebrow: 'Hair and scalp', title: 'What do you want to fix about your hair?', sub: 'Pick up to 2.', type: 'multi', max: 2,
      when: function (a) { return has(a.concerns, 'hair'); },
      options: [
        { v: 'dry', label: 'Dry, frizzy, straw-like', desc: 'Especially the ends' },
        { v: 'itchy', label: 'Itchy or flaky scalp', desc: 'Scratching, white flakes' },
        { v: 'buildup', label: 'Oily roots and build-up', desc: 'Greasy by day two' },
        { v: 'flat', label: 'Flat, no shine', desc: 'Looks dull even when clean' }
      ] },
    { id: 'lips', eyebrow: 'Your lips', title: 'What do you want your lips to do?', type: 'single',
      when: function (a) { return has(a.concerns, 'lips'); },
      options: [
        { v: 'heal', label: 'Heal', desc: 'They\'re cracked and peeling' },
        { v: 'hydrate', label: 'Stay soft all day', desc: 'Glossy, no sticky feel' },
        { v: 'tint', label: 'Tint', desc: 'A bit of colour that suits me' },
        { v: 'plump', label: 'Plump', desc: 'Fuller-looking lips' }
      ] },
    { id: 'sens', eyebrow: 'Your skin', title: 'How does your skin react to a scrub?', type: 'single',
      options: [
        { v: 'tough', label: 'Tough as nails', desc: 'Never reacts to anything' },
        { v: 'normal', label: 'Pretty normal', desc: 'Might go a bit pink, settles fast' },
        { v: 'sensitive', label: 'Sensitive', desc: 'Goes red, stings or itches' },
        { v: 'eczema', label: 'Eczema or psoriasis-prone', desc: 'Flares up easily' }
      ],
      why: 'This picks your glove. Sensitive skin gets our gentler weave, so you get the smooth without the sting.' },
    { id: 'habit', eyebrow: 'Your routine', title: 'How often do you exfoliate now?', type: 'single',
      options: [
        { v: 'never', label: 'Never. Total newbie', desc: '' },
        { v: 'sometimes', label: 'Now and then', desc: 'When I remember' },
        { v: 'weekly', label: 'Every week', desc: 'It\'s part of my routine' }
      ],
      why: 'This tells us what you\'ll see on your first go, so there are no surprises.' },
    { id: 'shower', eyebrow: 'Your shower', title: 'What\'s your shower doing to your skin?', sub: 'Pick all that apply.', type: 'multi', max: 4,
      options: [
        { v: 'weak', label: 'The pressure is weak', desc: '' },
        { v: 'hard', label: 'Water smells like chlorine', desc: 'Or leaves marks on the glass' },
        { v: 'tight', label: 'Skin feels tight or itchy after', desc: '' },
        { v: 'crunchy', label: 'Hair feels crunchy after washing', desc: '' },
        { v: 'fine', label: 'Nope, it\'s fine', desc: '', exclusive: true }
      ] },
    { id: 'size', eyebrow: 'Last one', title: 'How big do you want your routine?', type: 'single',
      options: [
        { v: 'simple', label: 'Just the essentials', desc: 'The 1 or 2 things that make the biggest difference' },
        { v: 'proper', label: 'The full routine', desc: '3 or 4 steps that work together. Our pick for real results' },
        { v: 'all', label: 'The total glow-up', desc: 'Everything your skin needs, all at once' }
      ] }
  ];

  /* ------------------------------------------------------------------
     RECOMMENDATION RULES
     ------------------------------------------------------------------ */
  var STEP_OF = {
    'skinvita-vitamin-beauty-shower-filter': 0, 'helix-booster-shower-head': 0, 'beauty-shower-intro-set': 0,
    'exfoliating-glove': 1, 'loofah-glove': 1, 'back-scrubber': 1, 'exfoliating-face-mitt': 1, 'dermablades': 1,
    'scalp-scrubber': 1, 'glass-foot-file': 1, 'foot-peel-mask': 1, 'makeup-eraser': 1,
    'glow-up-duo': 1, 'exfoliating-body-duo': 1, 'face-body-exfoliating-duo': 1, 'baby-smooth-set': 1, 'scrub-buff-set': 1, 'foot-reset-bundle': 1,
    'hypochlorous-acid-spray': 2, 'cheekyglo-ice-slushy-soothing-mask': 2, 'pdrn-plus-advanced-collagen-peptide-cream': 2,
    'peach-body-oil': 3, 'foot-balm': 3, 'lip-repair-essence': 3, 'lip-peptide-essence': 3, 'colour-changing-lip-oil': 3,
    'plumping-lip-oil': 3, 'silk-scrunchies-3-pack': 3
  };
  var STEP_NAMES = ['Shower upgrade', 'Exfoliate', 'Calm and treat', 'Hydrate'];
  var ROLE = { 'silk-scrunchies-3-pack': 'Protect', 'colour-changing-lip-oil': 'Tint', 'plumping-lip-oil': 'Plump', 'makeup-eraser': 'Cleanse', 'dermablades': 'Smooth' };
  var AREA = { rough: 'Body', kp: 'Body', bodyacne: 'Body', ingrown: 'Body', tan: 'Body', feet: 'Feet', face: 'Face', hair: 'Hair', lips: 'Lips', shower: 'Shower' };

  var BUNDLES = [
    { h: 'baby-smooth-set', parts: ['back-scrubber', 'exfoliating-glove', 'peach-body-oil'], prefs: function (v) { return [v.scrubber, v.glove]; } },
    { h: 'scrub-buff-set', parts: ['exfoliating-glove', 'glass-foot-file', 'peach-body-oil'], prefs: function (v) { return [v.glove, v.file]; } },
    { h: 'foot-reset-bundle', parts: ['foot-peel-mask', 'glass-foot-file', 'foot-balm'], prefs: function (v) { return [v.file]; } },
    { h: 'glow-up-duo', parts: ['exfoliating-glove', 'peach-body-oil'], prefs: function (v) { return [v.glove]; } },
    { h: 'exfoliating-body-duo', parts: ['exfoliating-glove', 'back-scrubber'], prefs: function (v) { return [v.glove, v.scrubber]; } },
    { h: 'face-body-exfoliating-duo', parts: ['exfoliating-glove', 'exfoliating-face-mitt'], prefs: function (v) { return [v.glove]; } },
    { h: 'beauty-shower-intro-set', parts: ['skinvita-vitamin-beauty-shower-filter', 'helix-booster-shower-head'], prefs: function (v) { return [v.scent]; } }
  ];

  var TITLES = {
    rough: 'Operation Soft Skin', kp: 'Operation Bye Bumps', bodyacne: 'Operation Clear Skin',
    ingrown: 'Operation Razor Rescue', tan: 'Operation Flawless Tan', feet: 'Operation Sandal Ready',
    face: 'Operation Face Card', hair: 'Operation Good Hair Day', lips: 'Operation Juicy Lips'
  };

  function variantPrefs(a) {
    var sensitive = a.sens === 'sensitive' || a.sens === 'eczema';
    var him = a.who === 'him';
    return {
      sensitive: sensitive,
      glove: sensitive ? 'Sensitive' : (him ? 'Black' : 'Pink'),
      scrubber: him ? 'Grey' : 'Pink',
      file: (a.feet === 'hard') ? 'Coarse' : 'Sensitive',
      scent: sensitive ? 'Original' : (him ? 'Ocean Breeze' : 'Rose Dew'),
      loofah: him ? 'Grey' : 'Pink',
      scalp: him ? 'Black' : 'Salmon',
      spray: '100mL'
    };
  }

  function prefsFor(h, v) {
    switch (h) {
      case 'exfoliating-glove': return [v.glove];
      case 'back-scrubber': return [v.scrubber];
      case 'glass-foot-file': return [v.file];
      case 'skinvita-vitamin-beauty-shower-filter': return [v.scent];
      case 'loofah-glove': return [v.loofah];
      case 'scalp-scrubber': return [v.scalp];
      case 'hypochlorous-acid-spray': return [v.spray];
      default:
        for (var i = 0; i < BUNDLES.length; i++) if (BUNDLES[i].h === h) return BUNDLES[i].prefs(v);
        return [];
    }
  }

  function pickVariant(h, prefs) {
    var p = P[h];
    if (!p) return null;
    var vs = p.variants;
    var match = vs.filter(function (x) {
      var parts = x.title.split(' / ');
      return prefs.every(function (tok, i) { return !tok || (parts[i] || '').indexOf(tok) !== -1; });
    });
    return match.filter(function (x) { return x.available; })[0] ||
      vs.filter(function (x) { return x.available; })[0] || null;
  }

  function build(a) {
    var v = variantPrefs(a);
    var picks = {};
    var order = [];
    function add(h, score, concern, reason) {
      if (!P[h]) return;
      if (!picks[h]) { picks[h] = { h: h, score: 0, reasons: [], concerns: [] }; order.push(h); }
      var p = picks[h];
      p.score += score;
      if (!has(p.concerns, concern)) p.concerns.push(concern);
      if (reason && !p.reasons.some(function (r) { return r.text === reason; })) p.reasons.push({ tag: tagOf(concern), text: reason });
    }
    function tagOf(c) { return CONCERNS[c] ? CONCERNS[c].tag : c === 'shower' ? 'Your shower' : 'Your skin'; }

    var concerns = a.concerns || [];
    var glove = v.sensitive ? 'Our Sensitive (White) glove is a gentler weave, so you get the smooth without the sting.' : '';

    concerns.forEach(function (c, rank) {
      var boost = (3 - rank) * 2;
      if (c === 'rough') {
        add('exfoliating-glove', 10 + boost, c, 'Buffs off the dry, flaky layer with just water. No scrub, no product. ' + glove);
        add('peach-body-oil', 7 + boost, c, 'Seals moisture in straight after you exfoliate, so the soft actually lasts.');
      }
      if (c === 'kp') {
        var areas = a.kpAreas || [];
        add('exfoliating-glove', 10 + boost, c, 'Gently lifts the keratin build-up that makes KP feel like sandpaper. ' + glove);
        add('peach-body-oil', 8 + boost, c, 'KP needs moisture as much as exfoliation. Oil onto damp skin right after the glove.');
        if (has(areas, 'back')) add('back-scrubber', 7 + boost, c, 'You said bumps on your back. The handles get the middle bit you can\'t reach.');
      }
      if (c === 'bodyacne') {
        var spots = a.acneAreas || [];
        if (v.sensitive) add('exfoliating-glove', 9 + boost, c, 'Clears the dead skin and sweat that clog body pores. ' + glove);
        else add('loofah-glove', 9 + boost, c, 'One side lathers your body wash, the other exfoliates, so pores get a proper clean in one go.');
        if (has(spots, 'back') || has(spots, 'shoulders')) add('back-scrubber', 9 + boost, c, 'Back and shoulder spots are hard to reach. This gets there without the gymnastics.');
        add('hypochlorous-acid-spray', 7 + boost, c, 'Mist on after your shower. Hypochlorous is gentle and calming on spotty, irritated skin.');
      }
      if (c === 'ingrown') {
        add('exfoliating-glove', 9 + boost, c, 'Clears the dead skin trapping hairs. Use it a day or two before you shave, not straight after. ' + glove);
        add('hypochlorous-acid-spray', 5 + boost, c, 'Calms razor bumps and redness after shaving.');
      }
      if (c === 'tan') {
        add('exfoliating-glove', 10 + boost, c, 'Preps skin for an even tan and lifts old tan when it goes patchy. ' + glove);
        add('peach-body-oil', 5 + boost, c, 'Keeps skin hydrated between tans so it fades evenly instead of flaking off in patches.');
      }
      if (c === 'feet') {
        if (a.feet === 'cracked') {
          add('foot-balm', 10 + boost, c, 'Urea and ceramides soften hard skin and help cracks repair. Rub in at night, socks on.');
          add('glass-foot-file', 6 + boost, c, 'Once the cracks settle, a gentle file stops the edges catching and splitting again.');
        } else if (a.feet === 'hard') {
          add('foot-peel-mask', 9 + boost, c, 'Acids and urea break down thick build-up so it sheds on its own over 7 to 14 days.');
          add('glass-foot-file', 9 + boost, c, 'Coarse glass buffs calluses down without cutting, and it won\'t rust like metal files.');
          add('foot-balm', 7 + boost, c, 'Keeps heels soft after the peel so the hard skin doesn\'t come straight back.');
        } else {
          add('glass-foot-file', 9 + boost, c, 'Quick buff on dry feet and the rough bits are gone. Rinses totally clean.');
          add('foot-balm', 6 + boost, c, 'A swipe at night keeps heels soft between files.');
        }
      }
      if (c === 'face') {
        var f = a.face || [];
        if (has(f, 'dull') || has(f, 'pores') || !f.length) add('exfoliating-face-mitt', 9 + boost, c, 'Turkish silk polishes off dull skin and gunk in pores, gently enough for your face.');
        if (has(f, 'pores')) add('hypochlorous-acid-spray', 7 + boost, c, 'Calms breakouts and keeps pores clean without drying your skin out.');
        if (has(f, 'red')) {
          add('hypochlorous-acid-spray', 8 + boost, c, 'A calming mist for red, reactive skin. Morning and night.');
          add('cheekyglo-ice-slushy-soothing-mask', 8 + boost, c, 'Icy-cold slushy mask with centella and niacinamide to take the heat out of redness.');
          add('pdrn-plus-advanced-collagen-peptide-cream', 7 + boost, c, 'Barrier-repair cream with ceramides and peptides for skin that reacts to everything.');
        }
        if (has(f, 'fuzz')) add('dermablades', 8 + boost, c, 'Takes off peach fuzz and dead skin so makeup sits smooth.');
        if (has(f, 'makeup')) add('makeup-eraser', 8 + boost, c, 'Just water. Takes off makeup, sunscreen and mascara without wipes or scrubbing.');
      }
      if (c === 'hair') {
        var hr = a.hair || [];
        if (has(hr, 'dry') || has(hr, 'flat') || !hr.length) add('skinvita-vitamin-beauty-shower-filter', 9 + boost, c, 'Filters chlorine and impurities out of your shower water, which is often what dries hair out.');
        if (has(hr, 'dry')) add('silk-scrunchies-3-pack', 5 + boost, c, 'Silk doesn\'t snag or crease, so dry ends stop snapping.');
        if (has(hr, 'itchy') || has(hr, 'buildup')) add('scalp-scrubber', 9 + boost, c, 'Massages out flakes and product build-up while you shampoo. Scalps love it.');
        if (has(hr, 'itchy')) add('skinvita-vitamin-beauty-shower-filter', 6 + boost, c, 'Chlorine can irritate your scalp. Filtered water is kinder to it.');
        if (has(hr, 'flat')) add('helix-booster-shower-head', 6 + boost, c, 'Stronger pressure rinses out product properly, so hair isn\'t weighed down.');
      }
      if (c === 'lips') {
        if (a.lips === 'heal') add('lip-repair-essence', 10 + boost, c, 'Shea, vitamin E and lanolin seal moisture in so cracked lips can actually heal.');
        if (a.lips === 'hydrate') add('lip-peptide-essence', 10 + boost, c, 'Peptides plus shea butter for soft, glassy lips without the sticky feel.');
        if (a.lips === 'tint') add('colour-changing-lip-oil', 10 + boost, c, 'Shifts to a shade that suits your lips, and hydrates while it does it.');
        if (a.lips === 'plump') add('plumping-lip-oil', 10 + boost, c, 'A cooling tip and a gentle tingle for fuller-looking lips in one swipe.');
      }
    });

    var sh = a.shower || [];
    if (has(sh, 'weak')) add('helix-booster-shower-head', 5, 'shower', 'You said the pressure is weak. Micro-nozzles boost it so rinses actually rinse.');
    if (has(sh, 'hard') || has(sh, 'tight') || has(sh, 'crunchy')) add('skinvita-vitamin-beauty-shower-filter', 5, 'shower', 'Chlorine can leave skin tight and hair crunchy. This filters it out and adds vitamin C.');

    // Two body gloves do the same job. Keep the stronger match and fold the other in.
    if (picks['exfoliating-glove'] && picks['loofah-glove']) {
      var g = picks['exfoliating-glove'], l = picks['loofah-glove'];
      var keep = g.score >= l.score ? g : l, drop = keep === g ? l : g;
      keep.score += drop.score;
      drop.concerns.forEach(function (c) { if (!has(keep.concerns, c)) keep.concerns.push(c); });
      drop.reasons.forEach(function (r) { keep.reasons.push(r); });
      delete picks[drop.h];
      order.splice(order.indexOf(drop.h), 1);
    }

    // Heroes for each concern go first, then the rest by score. The limit counts
    // cards after sets are formed, so a set that completes a routine still fits.
    var limit = a.size === 'simple' ? 2 : a.size === 'all' ? 6 : 4;
    var maxSingles = a.size === 'simple' ? 3 : a.size === 'all' ? 12 : 7;
    var list = order.map(function (h) { return picks[h]; }).sort(function (x, y) { return y.score - x.score; });
    // Round robin: best pick for each concern, then second best for each, and so on.
    var queue = [];
    for (var round = 0; round < 4; round++) {
      concerns.forEach(function (c) {
        var top = list.filter(function (p) { return has(p.concerns, c) && queue.indexOf(p) === -1; })[0];
        if (top) queue.push(top);
      });
    }
    list.forEach(function (p) { if (queue.indexOf(p) === -1) queue.push(p); });

    var chosen = [];
    var items = [];
    queue.forEach(function (p) {
      var variant = pickVariant(p.h, prefsFor(p.h, v));
      if (!variant) return;
      var trial = chosen.concat([{ h: p.h, variant: variant, reasons: p.reasons, concerns: p.concerns, score: p.score, on: true }]);
      var packed = bundle(trial, v);
      if (packed.length <= limit && trial.length <= maxSingles) { chosen = trial; items = packed; }
    });

    var rankOf = function (i) { var r = concerns.indexOf(i.concerns[0]); return r === -1 ? 9 : r; };
    items.sort(function (x, y) { return (rankOf(x) - rankOf(y)) || ((STEP_OF[x.h] || 0) - (STEP_OF[y.h] || 0)); });
    return { items: items, prefs: v };
  }

  // Swap groups of picks for a set when the set costs less.
  function bundle(singles, v) {
    var items = singles.slice();
    BUNDLES.forEach(function (b) {
      if (!P[b.h]) return;
      var parts = b.parts.map(function (h) { return items.filter(function (i) { return i.h === h && !i.parts; })[0]; });
      if (parts.some(function (x) { return !x; })) return;
      var bv = pickVariant(b.h, b.prefs(v));
      if (!bv) return;
      var sum = parts.reduce(function (t, i) { return t + i.variant.price; }, 0);
      if (bv.price >= sum) return;
      var reasons = [];
      parts.forEach(function (i) { if (i.reasons[0]) reasons.push({ tag: P[i.h].title.replace(/^CheekyGlo\s+/, ''), text: i.reasons[0].text }); });
      var first = items.indexOf(parts[0]);
      items = items.filter(function (i) { return parts.indexOf(i) === -1; });
      items.splice(Math.min(first, items.length), 0, {
        h: b.h, variant: bv, reasons: reasons, on: true, save: sum - bv.price,
        concerns: parts.reduce(function (all, i) { i.concerns.forEach(function (c) { if (!has(all, c)) all.push(c); }); return all; }, []),
        parts: parts.map(function (i) { return P[i.h].title.replace(/^CheekyGlo\s+/, ''); })
      });
    });
    return items;
  }

  function planTips(a, items) {
    var hs = items.map(function (i) { return i.h; }).join(' ');
    var tips = [];
    var bodyTool = /exfoliating-glove|loofah-glove|back-scrubber|glow-up-duo|body-duo|baby-smooth|scrub-buff|face-body/.test(hs);
    var sens = a.sens === 'sensitive' || a.sens === 'eczema';
    if (bodyTool) {
      tips.push(['Every session', 'Soak in a warm shower for 5+ minutes first. No soap or oil before it. Wring the glove out so it\'s damp, not dripping, and use firm strokes.']);
      tips.push(['How often', sens ? 'Once a week with light pressure to start, then twice a week once your skin is happy. Skip anything broken, sunburnt or flaring.' : 'Twice a week. Your skin rebuilds in the days between, and that\'s when the soft really shows.']);
      if (a.habit === 'never') tips.push(['Your first go', 'You\'ll see a lot roll off. That\'s totally normal, and it settles after a couple of sessions.']);
      if (a.habit === 'weekly') tips.push(['Your first go', 'You\'ll see less roll because you already exfoliate. It\'s still working, you just have less build-up to lift.']);
    }
    if (has(a.concerns, 'kp')) tips.push(['Weeks 3 to 4', 'Your KP feels noticeably smoother with glove plus oil. It won\'t vanish for good, but it calms right down.']);
    if (has(a.concerns, 'ingrown')) tips.push(['Shave days', 'Exfoliate 1 to 2 days before you shave, never on freshly shaved or waxed skin. Fewer ingrowns from your very next shave.']);
    if (has(a.concerns, 'tan')) tips.push(['Tan days', 'Glove the day before you tan, then moisturise knees, elbows and ankles just before. Your next tan goes on even and fades evenly.']);
    if (a.feet === 'cracked') tips.push(['Your heels', 'Balm every night with socks on and the cracks start closing up. Let them heal before any heavy filing.']);
    if (a.feet === 'hard') tips.push(['Your heels', 'Mask first and let it shed for 7 to 14 days (don\'t pull the skin). Then file and balm, and your heels stay smooth.']);
    if (/exfoliating-face-mitt|face-body/.test(hs)) tips.push(['Your face', 'Face mitt 2 to 3 times a week. Damp mitt, small circles, no scrubbing. Makeup sits smoother from the first go.']);
    if (/scalp-scrubber/.test(hs)) tips.push(['Your scalp', 'Use it with shampoo on wet hair for a minute or two. Gentle circles, no pressing hard. Your scalp feels fresh straight away.']);
    if (/skinvita|beauty-shower/.test(hs)) tips.push(['Day one', 'Your filter screws straight onto most handheld showers. Wall or rain shower? Grab the adapters too.']);
    tips.push(['After', 'Freshly exfoliated skin is delicate. Skip heavily fragranced products straight after.']);
    return tips;
  }

  /* ------------------------------------------------------------------
     FLOW
     ------------------------------------------------------------------ */
  var answers = {};
  var history = [];
  var current = null;
  var unlocked = false;
  var result = null;

  var screens = {};
  $$('[data-cgq-screen]').forEach(function (s) { screens[s.getAttribute('data-cgq-screen')] = s; });
  var top = $('[data-cgq-top]');
  var bar = $('[data-cgq-bar]');
  var sticky = $('[data-cgq-sticky]');

  function show(name) {
    Object.keys(screens).forEach(function (k) { screens[k].classList.toggle('cgq-on', k === name); });
    top.hidden = name === 'intro' || name === 'results';
    sticky.hidden = name !== 'results';
    var rect = root.getBoundingClientRect();
    if (rect.top < 0 || rect.top > window.innerHeight * 0.4) {
      window.scrollTo({ top: window.pageYOffset + rect.top - 90, behavior: 'smooth' });
    }
  }

  function visibleSteps() {
    return STEPS.filter(function (s) { return !s.when || s.when(answers); });
  }

  function progress() {
    var vis = visibleSteps();
    var i = vis.indexOf(current);
    var pct = Math.round(((i + 1) / (vis.length + 1)) * 100);
    bar.firstElementChild.style.width = pct + '%';
    bar.setAttribute('aria-valuenow', pct);
  }

  function nextStep() {
    var vis = visibleSteps();
    var i = current ? vis.indexOf(current) : -1;
    var n = vis[i + 1];
    if (current) history.push(current);
    if (n) { current = n; renderStep(); } else { current = null; finish(); }
  }

  function prevStep() {
    var p = history.pop();
    if (!p) { current = null; show('intro'); return; }
    current = p;
    renderStep();
  }

  function renderStep() {
    var s = current;
    var el = screens.question;
    var html;
    if (s.type === 'insight') {
      var c = (answers.concerns || [])[0] || 'rough';
      var ins = INSIGHTS[c];
      html = '<div class="cgq-q__in cgq-insight">' +
        '<p class="cgq-eyebrow">Good to know</p>' +
        '<h2 class="cgq-h2" tabindex="-1">' + esc(ins[0]) + '</h2>' +
        '<p class="cgq-lead">' + esc(ins[1]) + '</p>' +
        '<p class="cgq-insight__note">The good news: it\'s fixable. A few more questions and your routine is ready.</p>' +
        '<div class="cgq-next"><button type="button" class="cgq-btn" data-cgq-next>Keep going</button></div>' +
        '</div>';
    } else {
      var sel = answers[s.id];
      var picked = function (v) { return s.type === 'multi' ? has(sel, v) : sel === v; };
      html = '<div class="cgq-q__in">' +
        '<p class="cgq-eyebrow">' + esc(s.eyebrow) + '</p>' +
        '<h2 class="cgq-h2" tabindex="-1">' + esc(s.title) + '</h2>' +
        (s.sub ? '<p class="cgq-lead">' + esc(s.sub) + '</p>' : '') +
        '<div class="cgq-opts' + (s.cols === 'wide' ? ' cgq-opts--wide' : '') + '" role="group" aria-label="' + esc(s.title) + '">' +
        s.options.map(function (o, i) {
          var rank = s.type === 'multi' && s.id === 'concerns' && has(sel, o.v) ? sel.indexOf(o.v) + 1 : '';
          return '<button type="button" class="cgq-opt" data-v="' + esc(o.v) + '" aria-pressed="' + picked(o.v) + '">' +
            '<span class="cgq-opt__mark" aria-hidden="true">' + (rank || '') + '</span>' +
            '<span class="cgq-opt__txt"><span class="cgq-opt__label">' + esc(o.label) + '</span>' +
            (o.desc ? '<span class="cgq-opt__desc">' + esc(o.desc) + '</span>' : '') + '</span></button>';
        }).join('') +
        '</div>' +
        (s.why ? '<p class="cgq-why">' + esc(s.why) + '</p>' : '') +
        (s.type === 'multi' ? '<div class="cgq-next"><button type="button" class="cgq-btn" data-cgq-next' + ((sel && sel.length) ? '' : ' disabled') + '>Next</button><p class="cgq-hint" data-cgq-hint></p></div>' : '') +
        '</div>';
    }
    el.innerHTML = html;
    show('question');
    progress();
    var h = el.querySelector('h2');
    if (h) h.focus({ preventScroll: true });
  }

  screens.question.addEventListener('click', function (e) {
    var s = current;
    if (!s) return;
    if (e.target.closest('[data-cgq-next]')) { nextStep(); return; }
    var btn = e.target.closest('.cgq-opt');
    if (!btn) return;
    var v = btn.getAttribute('data-v');
    if (s.type === 'single') {
      answers[s.id] = v;
      $$('.cgq-opt', screens.question).forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
      setTimeout(nextStep, 240);
      return;
    }
    var list = (answers[s.id] || []).slice();
    var opt = s.options.filter(function (o) { return o.v === v; })[0];
    var hint = $('[data-cgq-hint]', screens.question);
    if (has(list, v)) list.splice(list.indexOf(v), 1);
    else if (opt.exclusive) list = [v];
    else {
      list = list.filter(function (x) { return !s.options.some(function (o) { return o.v === x && o.exclusive; }); });
      if (list.length >= s.max) {
        if (hint) { hint.textContent = 'You can pick up to ' + s.max + '. Tap one to swap it out.'; }
        return;
      }
      list.push(v);
    }
    if (hint) hint.textContent = '';
    answers[s.id] = list;
    $$('.cgq-opt', screens.question).forEach(function (b) {
      var bv = b.getAttribute('data-v');
      b.setAttribute('aria-pressed', String(has(list, bv)));
      if (s.id === 'concerns') b.querySelector('.cgq-opt__mark').textContent = has(list, bv) ? list.indexOf(bv) + 1 : '';
    });
    $('[data-cgq-next]', screens.question).disabled = !list.length;
  });

  function finish() {
    result = build(answers);
    save();
    track('cg_quiz_complete', { quiz_concerns: (answers.concerns || []).join(','), quiz_items: result.items.length });
    var lines = [];
    (answers.concerns || []).slice(0, 2).forEach(function (c) { lines.push('Matching your tools to ' + CONCERNS[c].phrase); });
    if (answers.sens === 'sensitive' || answers.sens === 'eczema') lines.push('Picking the gentle options for sensitive skin');
    lines.push('Finding the sets that save you money');
    var list = $('[data-cgq-load-list]');
    list.innerHTML = lines.map(function (l) { return '<li>' + esc(l) + '</li>'; }).join('');
    show('loading');
    var items = $$('li', list);
    items.forEach(function (li, i) { setTimeout(function () { li.classList.add('cgq-done'); }, 350 + i * 450); });
    setTimeout(function () {
      if (cfg.askEmail && !unlocked) show('email');
      else renderResults();
    }, 500 + items.length * 450);
  }

  /* Email */
  var emailForm = $('[data-cgq-email-form]');
  emailForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = emailForm.querySelector('input');
    var email = input.value.trim();
    var err = $('[data-cgq-email-err]');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.hidden = false; input.focus(); return; }
    err.hidden = true;
    unlocked = true;
    subscribe(email);
    save();
    renderResults();
  });
  $('[data-cgq-skip]').addEventListener('click', function () { renderResults(); });

  function subscribe(email) {
    var concernTags = (answers.concerns || []).map(function (c) { return 'quiz-' + c; });
    try {
      var body = new URLSearchParams();
      body.append('form_type', 'customer');
      body.append('utf8', '✓');
      body.append('contact[email]', email);
      body.append('contact[tags]', ['newsletter', 'skin-quiz'].concat(concernTags).join(','));
      fetch(cfg.root + 'contact', { method: 'POST', body: body, headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).catch(function () {});
    } catch (e) {}
    try {
      var props = {
        email: email,
        quiz_concerns: (answers.concerns || []).join(', '),
        quiz_sensitivity: answers.sens || '',
        quiz_for: answers.who || '',
        quiz_routine: result ? result.items.map(function (i) { return P[i.h].title; }).join(', ') : ''
      };
      var k = window.klaviyo || (window._learnq = window._learnq || []);
      k.push(['identify', props]);
      k.push(['track', 'Completed Skin Quiz', props]);
    } catch (e) {}
    track('cg_quiz_email');
  }

  /* ------------------------------------------------------------------
     RESULTS
     ------------------------------------------------------------------ */
  function codeActive() { return !!cfg.discountCode && (unlocked || !cfg.codeNeedsEmail); }

  function renderResults() {
    var a = answers;
    var items = result.items;
    var first = (a.concerns || [])[0] || 'rough';
    var forWho = a.who === 'me' ? 'Your' : 'Their';
    $('[data-cgq-res-eyebrow]').textContent = forWho + ' glow plan';
    $('[data-cgq-res-title]').textContent = TITLES[first];
    var sensTxt = { tough: 'tough skin', normal: 'normal skin', sensitive: 'sensitive skin', eczema: 'eczema-prone skin' }[a.sens] || 'your skin';
    var mine = a.who === 'me';
    $('[data-cgq-res-lead]').textContent = 'Built for ' + (mine ? 'your ' : 'their ') +
      [sensTxt].concat((a.concerns || []).map(function (c) { return CONCERNS[c].phrase; })).join(', ').replace(/, ([^,]*)$/, ' and $1') +
      '. Here\'s everything ' + (mine ? 'you' : 'they') + ' need, and exactly why each piece made the cut.';
    var chips = (a.concerns || []).map(function (c) { return CONCERNS[c].tag; });
    chips.push(sensTxt.charAt(0).toUpperCase() + sensTxt.slice(1));
    if (a.habit === 'never') chips.push('First-timer');
    $('[data-cgq-res-chips]').innerHTML = chips.map(function (c) { return '<li>' + esc(c) + '</li>'; }).join('');

    var steps = $('[data-cgq-res-steps]');
    steps.innerHTML = items.length ? items.map(card).join('') :
      '<p class="cgq-empty">We couldn\'t find a match in stock right now. <a href="/collections/all">Browse everything</a>.</p>';

    $('[data-cgq-plan-list]').innerHTML = planTips(a, items).map(function (t) {
      return '<li><b>' + esc(t[0]) + '</b><span>' + esc(t[1]) + '</span></li>';
    }).join('');

    show('results');
    summary();
    var h = $('[data-cgq-res-title]');
    h.setAttribute('tabindex', '-1');
    h.focus({ preventScroll: true });
  }

  function card(item, i) {
    var p = P[item.h];
    var v = item.variant;
    var img = v.image || p.image;
    var step = (AREA[item.concerns[0]] || 'Body') + ' &middot; ' + (item.parts ? 'The set' : ROLE[item.h] || STEP_NAMES[STEP_OF[item.h] || 0]);
    var opts = p.variants.length > 1 ? '<label class="cgq-sr" for="cgq-v-' + i + '">Option</label><select id="cgq-v-' + i + '" class="cgq-card__sel" data-cgq-variant="' + i + '">' +
      p.variants.map(function (x) {
        return '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + (x.available ? '' : ' disabled') + '>' + esc(x.title) + (x.available ? '' : ' (sold out)') + '</option>';
      }).join('') + '</select>' : '';
    var rating = p.reviews > 0 ? '<p class="cgq-card__rating"><span class="cgq-stars" aria-hidden="true">&#9733;</span> ' + Number(p.rating).toFixed(1) + ' <span>(' + Number(p.reviews).toLocaleString('en-AU') + ' reviews)</span></p>' : '';
    return '<article class="cgq-card" data-cgq-item="' + i + '">' +
      '<a class="cgq-card__img" href="' + esc(p.url) + '" target="_blank" rel="noopener">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="240" height="240">' : '') + '</a>' +
      '<div class="cgq-card__head">' +
        '<p class="cgq-label">' + step + (item.save ? ' <span class="cgq-badge">You save ' + money(item.save) + ' as a set</span>' : '') + '</p>' +
        '<h3 class="cgq-card__title"><a href="' + esc(p.url) + '" target="_blank" rel="noopener">' + esc(p.title) + '</a></h3>' +
        rating +
        (item.parts ? '<p class="cgq-card__incl">Includes ' + esc(item.parts.join(', ').replace(/, ([^,]*)$/, ' and $1')) + '</p>' : '') +
      '</div><div class="cgq-card__more">' +
        '<ul class="cgq-card__why unstyled-list">' + item.reasons.slice(0, 3).map(function (r) {
          return '<li><b>' + esc(r.tag) + ':</b> ' + esc(r.text.trim()) + '</li>';
        }).join('') + '</ul>' +
        '<div class="cgq-card__foot">' + opts +
          '<p class="cgq-card__price" data-cgq-price="' + i + '"></p>' +
          '<label class="cgq-card__keep"><input type="checkbox" data-cgq-keep="' + i + '" checked> In my routine</label>' +
        '</div>' +
      '</div></article>';
  }

  screens.results.addEventListener('change', function (e) {
    var t = e.target;
    if (t.hasAttribute('data-cgq-variant')) {
      var item = result.items[+t.getAttribute('data-cgq-variant')];
      var nv = P[item.h].variants.filter(function (x) { return String(x.id) === t.value; })[0];
      if (nv) item.variant = nv;
      var img = nv && (nv.image || P[item.h].image);
      var im = t.closest('.cgq-card').querySelector('.cgq-card__img img');
      if (img && im) im.src = img;
    }
    if (t.hasAttribute('data-cgq-keep')) {
      var it = result.items[+t.getAttribute('data-cgq-keep')];
      it.on = t.checked;
      t.closest('.cgq-card').classList.toggle('cgq-card--off', !t.checked);
    }
    summary();
  });

  function summary() {
    var items = result.items;
    var on = items.filter(function (i) { return i.on; });
    var sub = on.reduce(function (t, i) { return t + i.variant.price; }, 0);
    var save = on.reduce(function (t, i) { return t + (i.save || 0); }, 0);
    items.forEach(function (it, i) {
      var el = $('[data-cgq-price="' + i + '"]');
      if (!el) return;
      var cmp = it.variant.compare > it.variant.price ? it.variant.compare : (it.save ? it.variant.price + it.save : 0);
      el.innerHTML = money(it.variant.price) + (cmp ? ' <s>' + money(cmp) + '</s>' : '');
    });
    $('[data-cgq-sum-lines]').innerHTML = on.map(function (i) {
      return '<li><span>' + esc(P[i.h].title.replace(/^CheekyGlo\s+/, '')) + '</span><span>' + money(i.variant.price) + '</span></li>';
    }).join('') || '<li><span>Nothing selected yet</span><span></span></li>';
    var saveEl = $('[data-cgq-sum-save]');
    saveEl.hidden = !save;
    saveEl.innerHTML = '<span>Set savings</span><span>-' + money(save) + '</span>';
    var codeEl = $('[data-cgq-sum-code]');
    var total = sub;
    if (codeActive() && sub) {
      var off = Math.round(sub * (cfg.discountPercent || 0) / 100);
      total = sub - off;
      codeEl.hidden = false;
      codeEl.innerHTML = '<span>' + esc(cfg.discountCode) + ' (' + cfg.discountPercent + '% off)</span><span>-' + money(off) + '</span>';
    } else codeEl.hidden = true;
    $('[data-cgq-sum-total]').innerHTML = (total !== sub ? '<s>' + money(sub) + '</s> ' : '') + money(total);
    var ship = $('[data-cgq-sum-ship]');
    if (cfg.freeShip > 0 && sub) ship.textContent = total >= cfg.freeShip ? 'Free shipping unlocked.' : 'Add ' + money(cfg.freeShip - total) + ' more and your shipping is free.';
    else ship.textContent = '';
    $('[data-cgq-sum-afterpay]').textContent = total ? 'Or 4 interest-free payments of ' + money(total / 4) + ' with Afterpay.' + (codeActive() ? ' Your ' + cfg.discountPercent + '% off is applied automatically.' : '') : '';
    $('[data-cgq-sticky-total]').textContent = money(total);
    $('[data-cgq-sticky-count]').textContent = on.length + (on.length === 1 ? ' item' : ' items');
    $$('[data-cgq-add]').forEach(function (b) { b.disabled = !on.length; });
  }

  /* Add to cart. Draws the drawer at once through the instant cart, then confirms. */
  var adding = false;
  root.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cgq-add]') || adding) return;
    var on = result.items.filter(function (i) { return i.on; });
    if (!on.length) return;
    adding = true;
    var buttons = $$('[data-cgq-add]');
    buttons.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    var err = $('[data-cgq-add-err]');
    err.hidden = true;

    var lines = on.map(function (i) {
      var p = P[i.h];
      return { id: i.variant.id, quantity: 1, title: p.title, variant_title: i.variant.title === 'Default Title' ? '' : i.variant.title, image: i.variant.image || p.image, line_price: i.variant.price };
    });
    document.dispatchEvent(new CustomEvent('cg:instant-add', { detail: { lines: lines } }));

    var attrs = { 'Skin quiz': (answers.concerns || []).join(', ') + ' | ' + (answers.sens || '') };
    var pre = { attributes: attrs };
    var jsonHead = { 'Content-Type': 'application/json', Accept: 'application/json' };
    var codeStep = codeActive()
      ? fetch(cfg.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          var codes = (cart.discount_codes || []).map(function (c) { return c.code; })
            .filter(function (c) { return String(c).toLowerCase() !== cfg.discountCode.toLowerCase(); });
          codes.push(cfg.discountCode);
          pre.discount = codes.join(',');
        }).catch(function () { pre.discount = cfg.discountCode; })
      : Promise.resolve();

    codeStep
      .then(function () { return fetch(cfg.root + 'cart/update.js', { method: 'POST', headers: jsonHead, body: JSON.stringify(pre) }).catch(function () {}); })
      .then(function () {
        return fetch(cfg.root + 'cart/add.js', {
          method: 'POST',
          headers: Object.assign({ 'X-Requested-With': 'XMLHttpRequest' }, jsonHead),
          body: JSON.stringify({ items: lines.map(function (l) { return { id: l.id, quantity: 1 }; }) })
        });
      })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok || d.status) throw d; return d; }); })
      .then(function () {
        track('cg_quiz_add', { quiz_items: lines.length });
        return refreshDrawer();
      })
      .catch(function (x) {
        document.dispatchEvent(new CustomEvent('cg:instant-add-failed'));
        err.textContent = (x && (x.description || x.message)) || 'Your routine didn\'t make it to the cart. Tap the button to try again.';
        err.hidden = false;
      })
      .then(function () {
        adding = false;
        buttons.forEach(function (b) { b.removeAttribute('aria-busy'); });
        summary();
      });
  });

  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    var wrap = (drawer && drawer.closest('.shopify-section')) || document.querySelector('[id^="shopify-section-"][id$="cart-drawer"]');
    var sectionId = wrap ? wrap.id.replace('shopify-section-', '') : null;
    var reqs = [fetch(cfg.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })];
    if (sectionId) reqs.push(fetch(cfg.root + '?sections=' + encodeURIComponent(sectionId)).then(function (r) { return r.json(); }));
    return Promise.all(reqs).then(function (res) {
      var cart = res[0];
      if (res[1]) cart.sections = res[1];
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
      if (!sectionId) window.location.href = cfg.root + 'cart';
    }).catch(function () {});
  }

  /* Sticky bar only while the summary button is off screen (mobile) */
  if ('IntersectionObserver' in window) {
    var mainAdd = $('.cgq-sum [data-cgq-add]');
    new IntersectionObserver(function (en) {
      root.classList.toggle('cgq-sum-visible', en[0].isIntersecting);
    }).observe(mainAdd);
  }

  /* Save + restore */
  function save() {
    try { localStorage.setItem(STORE, JSON.stringify({ a: answers, u: unlocked, t: Date.now() })); } catch (e) {}
  }
  function restore() {
    try {
      var s = JSON.parse(localStorage.getItem(STORE) || 'null');
      if (!s || !s.a || !s.a.concerns || Date.now() - s.t > 1000 * 60 * 60 * 24 * 30) return null;
      return s;
    } catch (e) { return null; }
  }

  var saved = restore();
  unlocked = !!(saved && saved.u);
  if (saved) {
    var intro = screens.intro.querySelector('.cgq-intro__text');
    var back = document.createElement('p');
    back.className = 'cgq-welcome';
    back.innerHTML = 'Done this before? <button type="button" class="cgq-link" data-cgq-last>See your last routine</button>';
    intro.insertBefore(back, intro.querySelector('.cgq-points'));
    back.querySelector('button').addEventListener('click', function () {
      answers = saved.a;
      unlocked = !!saved.u;
      result = build(answers);
      renderResults();
    });
  }

  $('[data-cgq-start]').addEventListener('click', function () {
    answers = {}; history = []; current = null;
    track('cg_quiz_start');
    nextStep();
  });
  $('[data-cgq-back]').addEventListener('click', prevStep);
  $('[data-cgq-retake]').addEventListener('click', function () {
    answers = {}; history = []; current = null;
    track('cg_quiz_start', { quiz_retake: true });
    nextStep();
  });
})();
